
const digest = '0a8282d6016c7869a13e06ef38fe73640d0c347bf72303115b45c863c29a4706';
const classes = {"wrapper":"_wrapper_1dl9q_1","list":"_list_1dl9q_9"};
const css = `._wrapper_1dl9q_1 {
  font-family: "Rubik", sans-serif;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  height: 100%;
}
._wrapper_1dl9q_1 ._list_1dl9q_9 {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow-y: scroll;
  box-shadow: inset 0 4px 0 0 rgba(226, 229, 237, 0.3);
  -ms-overflow-style: auto;
  scrollbar-width: 3px;
  border: 1px solid #eaedf4;
  border-top: 0;
}
._wrapper_1dl9q_1 ._list_1dl9q_9::-webkit-scrollbar {
  display: block;
}
._wrapper_1dl9q_1 ._list_1dl9q_9::-webkit-scrollbar {
  width: 4px;
  height: 4px;
  padding: 2px;
}
._wrapper_1dl9q_1 ._list_1dl9q_9::-webkit-scrollbar-track {
  background: #f1f1f1;
}
._wrapper_1dl9q_1 ._list_1dl9q_9::-webkit-scrollbar-thumb {
  background: #3e3f42;
  border-radius: 4px;
}
._wrapper_1dl9q_1 ._list_1dl9q_9::-webkit-scrollbar-thumb:hover {
  background: #3e3f42;
  border-radius: 4px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  